import styles from "./styles.module.css"

function Button({className, outline, children, ...props}){
    
    if(outline){
        return(
            <button className={`${styles.outlineButton} ${className}`} {...props}>
              {children}
            </button>
        )
    }

    return(
        <button className={`${styles.button} ${className}`} {...props}>
          {children}
        </button>
    )
}

export default Button